<fieldset
	class="drop-container"
	cdxFieldset
	legend="{{ label }}"
	[i18n]="'@@form-title'"
	[formGroup]="group"
	layout="large"
>
	<div>
		<select [formControlName]="formControlName">
			<option *ngFor="let option of options" [value]="option.value" [attr.selected]="option.selected ? true : null">
				{{ option.text }}
			</option>
		</select>
	</div>
	<form-input-error validation [control]="formControlName">
		<p cdxInvalidType="required" i18n="@@dcForm-RequiredError">Please select an item from the list.</p>
	</form-input-error>
</fieldset>
